import React, {FC, useState} from 'react';
import { ReactComponent as UserIcon } from '../../../../assets/icons/commons/user.svg';
import { Button } from '../Button/Button';
import styles from './NavProfile.module.css';
import { BASE_BUCKET, BASE_IMAGE_URL, DEFAULT_ONEID_HOST } from '../../../../utils/constants';
import { generateEnvDomain } from '../../../../utils/generateEnvDomain';
import { INavProfileProps } from "../../../../declarations/types";
import cn from 'classnames';
import {ArrowDown} from "../../../../assets/icons/ArrowDown";

let defaultOneIdHost = DEFAULT_ONEID_HOST;
defaultOneIdHost = generateEnvDomain(defaultOneIdHost);

if (process.env.REACT_APP_UNIONE_COMMONS_ONEID_HOST) {
  defaultOneIdHost = process.env.REACT_APP_UNIONE_COMMONS_ONEID_HOST;
}

export const NavProfile: FC<INavProfileProps> = ({
   photoUrl,
   userName,
   isAuth,
   onLogout,
   onLogin,
   userFullName,
   isDark,
   s3Token,
}) => {
  const [showActions, setShowActions] = useState<boolean>(false)
  const imageHost = generateEnvDomain(BASE_IMAGE_URL);

  const toggleDropdown = () => {
    if (showActions) {
        setShowActions(false);
    } else {
      setShowActions(true);
    }
  };

  const onConfirmLogoutHandler = () => {
    if (onLogout) {
      onLogout();
    }
  };

  const onLoginHandler = () => {
    if (onLogin) {
      const isEnter = true;
      onLogin(isEnter);
    }
  };

  const avatarUrlFunc = (
    currentTarget: EventTarget & HTMLImageElement,
  ) => {
    if (currentTarget.src !== `${imageHost}/${photoUrl}?s3token=${s3Token}`) {
      currentTarget.src = `${imageHost}/${photoUrl}?s3token=${s3Token}`
    }
  };

  const redirect = `${defaultOneIdHost}?redirect=${encodeURIComponent(window.location.origin)}`;
  const btnTheme = cn( styles.userName, { [styles.userNameDark]: isDark, }, );

  return (
    <div className={styles.commonsNavProfile}>
      <div className={styles.wrapper}>
        {isAuth ? (
          <>
            <div className={styles.user} onClick={toggleDropdown}>
              <div className={styles.userAvatar}>
                {photoUrl ? (
                  <img
                    src={`${imageHost}/${BASE_BUCKET}/${photoUrl}?s3token=${s3Token}`}
                    alt="avatar_thumb"
                    onError={({ currentTarget }) => avatarUrlFunc(currentTarget)}
                  />
                ) : (
                  <UserIcon className={styles.default}/>
                )}
              </div>

              <div className={styles.userName}>
                {userName || ''}
              </div>

              <div className={cn(styles.dropdownArrow, { [styles.open]: showActions })}>
                <ArrowDown/>
              </div>

              <div className={cn(styles.userActions, {
                [styles.show]: showActions,
                [styles.hide]: !showActions,
              })}>
                <a
                  href={redirect}
                  className={styles.userActionsButton}
                >
                  Профиль
                </a>
                <button
                  type="button"
                  className={cn(styles.userActionsButton)}
                  onClick={onConfirmLogoutHandler}
                >
                  Выход
                </button>
              </div>
            </div>
          </>
        ) : userFullName?.length
          ? <div className={styles.user}>
            <div className={styles.userAvatar}>
              {photoUrl ? (
                <img
                  src={photoUrl}
                  alt="avatar_thumb"
                  onError={({ currentTarget }) => avatarUrlFunc(currentTarget)}
                />
              ) : (
                <UserIcon/>
              )}
            </div>

            <div className={btnTheme}>
              {userFullName || ''}
            </div>
          </div>
          : (
            <Button
              onClick={onLoginHandler}
            >
              Вход
            </Button>
          )}
      </div>
    </div>
  );
};
